import { createSimpleLifecycle } from "./lifecycle";
export function onWillMount(callback) {
    return createSimpleLifecycle("componentWillMountCallback", callback);
}
export default onWillMount;

//# sourceMappingURL=onWillMount.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/onWillMount.js
// module id = 60
// module chunks = 0